<template>
  <div id="use-plex-step">
    <div class="details" v-for="(detail, index) in currentPlatformSteps">
      <!-- <p class="vertical-middle img-box"><img v-bind:src="detail.imgUrl"></p>
      <div class="vertical-middle explain-box">
        <p class="little-title"><span class="number">{{index + 1}}</span>
          <router-link to="/register" v-if="detail.signUp">{{ detail.signUp }}</router-link>{{ detail.title }}
        </p>
        <p class="explain">{{ detail.explain }}</p>
        <img v-bind:src="detail.imgUrl">
        <div>
          <h2>{{ detail.title }}</h2>
          <p>{{ detail.explain }}</p>
        </div>
      </div> -->
      <h3>{{ $t('step') }} {{ index+1 }}</h3>
      <img :src="detail.imgUrl" alt="">
      <h4>{{ detail.title }}</h4>
      <p>{{ detail.explain }}</p>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import _ from 'lodash'

  export default {
    name: 'use-plex-step',
    locales,
    data: function () {
      return {
        pc: [{
          imgUrl: '../../static/img/downloadNew/img_pc_1.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_pc_2.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_pc_3.png'
        }],
        ios: [{
          imgUrl: '../../static/img/downloadNew/img_ios_1.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_ios_2.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_ios_3.png'
        }],
        android: [{
          imgUrl: '../../static/img/downloadNew/img_android_1.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_android_2.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_android_3.png'
        }],
        androidTV: [{
          imgUrl: '../../static/img/downloadNew/img_tv_1.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_tv_2.png'
        }, {
          imgUrl: '../../static/img/downloadNew/img_tv_3.png'
        }]
      }
    },
    computed: {
      currentPlatform() {
        return this.$store.state.download.currentPlatform
      },
      currentPlatformSteps() {
        if (this.currentPlatform === 'windows') {
          return _.merge(this.pc, this.$t('pc'))
        }
        if (this.currentPlatform === 'mac') {
          return _.merge(this.pc, this.$t('mac'))
        }
        if (this.currentPlatform === 'ubuntu') {
          return _.merge(this.pc, this.$t('ubuntu'))
        }
        return _.merge(this[this.currentPlatform], this.$t(this.currentPlatform))
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    border: 0;
  }

  #use-plex-step {
    padding: 0 calc((100% - 11.8rem) / 2);
    display:flex;
    justify-content:space-between;
  }

  button:hover {
    outline: 0;
  }

  .details {
    width: 30%;
    max-width: 10rem;
    text-align: center;
    margin-bottom: 1.8rem;
    h3 {
      font-size: 32px;
      color: #000000;
      line-height: 48px;
      font-weight: 600;
      margin: 0 0 24px;
    }
    img {
      width: 300px;
      height: auto;
    }
    h4 {
      margin: 24px 0 16px;
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    p {
      font-size: 16px;
      color: #666666;
      line-height: 22px;
      letter-spacing: 1px;
      margin-bottom: 0;
    }
  }
  @media screen and (min-width: 992px) {
    .details {
      max-width: 10rem;
    }
  }
  @media screen and (max-width: 1228px){
    #use-plex-step{
      padding:0 24px;
      margin-top:-1px;
      .details {
        margin-bottom: 1.2rem;
        p {
          font-size: 15px;
        }
      }
    }
  }

  @media screen and (max-width: 820px) {
    #use-plex-step{
      display:block;
      padding:0 .24rem .8rem;
      .details {
        display: block;
        text-align: center;
        width: 100%;
        margin: .4rem 0 0;
        h3 {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 16px;
        }
        img {
          width: 100%;
        }
        h4 {
          margin: 16px 0 8px;
          font-size: 18px;
          line-height: 24px;
        }
        p {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
  
@media screen and (max-width: 820px) and (min-width: 768px) {
  #use-plex-step .details img {
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// UsePlexStep.vue?230115fc